import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";
import { setIsModalxOpen } from "components/modalx/modalx.slice";
import { fetchCustomer } from "containers/customer/customer-container.slice";
import { fetchProject } from "containers/project-view-container/project-container.slice";
import { fetchCategoryFilesDetails } from "containers/document/category-files/catFiles.Slice";
import { fetchCategoryDetails } from "containers/document/category-tree/category-tree.Slice";
import { fetchUserDetails } from "containers/user/user-container.slice";
import { fetchFileDetails } from "containers/file/file.Slice";
import { patchFile } from "services/upload-file.service";
import { fetchAssetDetails } from "containers/asset-view-container/asset-container.slice";
import { fetchFinanceDetailRefreshAsync } from "containers/finance-detail/finance-detail-container.slice";

const initialState = {
  isLoading: false,
  isError: false,
  isSuccessfullySaved: false,
  errMsg: null,
};
const fileFormSlice = createSlice({
  name: "fileForm",
  initialState,
  /* eslint-disable no-param-reassign */
  reducers: {
    setLoading(state) {
      state.isLoading = true;
    },
    setError(state, action) {
      state.isLoading = false;
      state.isError = true;
      state.errMsg = action.payload.error;
    },
    setSuccessfullySaved(state) {
      state.isLoading = false;
      state.isError = false;
      state.errMsg = null;
      state.isSuccessfullySaved = true;
    },
    destroy(state) {
      _.assign(state, initialState);
    },
  },
  /* eslint-enable */
});

// Extract the action creators object and the reducer
const { actions, reducer } = fileFormSlice;

// Extract and export each action creator by name
export const { setLoading, setError, setSuccessfullySaved, destroy } = actions;

// Export the reducer, either as a default or named export
export default reducer;

export const submit = (data) => async (dispatch, getState) => {
  dispatch(setLoading());
  try {
    const {
      isCustomerSelectorVisible,
      companyId,
      targetCategoryId,
      userId,
      projectId,
      assetId,
      ...apiParams
    } = data;
    await patchFile(apiParams, companyId);

    // Check if this is a finance document (sanctions or VAT check)
    const isFinanceDocument = data.customerId && data.year && (data.sanctionsType || data.isVatCheckDocument);

    if (data.relatedTo)
      dispatch(fetchFileDetails({ fileId: data.relatedTo, companyId }));

    // For finance documents, skip fetchCustomer since fetchFinanceDetailRefreshAsync will handle it
    if (data.customerId && !isFinanceDocument) {
      dispatch(fetchCustomer({ companyId, customerId: data.customerId }));
    }

    if (targetCategoryId)
      dispatch(
        fetchCategoryFilesDetails({ companyId, catId: targetCategoryId })
      );
    if (companyId) dispatch(fetchCategoryDetails({ companyId }));
    if (data.id) dispatch(fetchFileDetails({ fileId: data.id, companyId }));
    if (userId) dispatch(fetchUserDetails({ userId, companyId }));
    if (projectId) dispatch(fetchProject({ companyId, projectId }));
    if (assetId) dispatch(fetchAssetDetails({ companyId, id: assetId }));

    // Refresh finance detail for sanctions or VAT check documents
    if (isFinanceDocument) {
      const state = getState();
      const financeId =
        data.customerFinance ||
        data.financeId ||
        state.financeDetailReducer?.financeDetail?.financeRecord?.id;
      dispatch(fetchFinanceDetailRefreshAsync({
        companyId,
        customerId: data.customerId,
        year: data.year,
        financeId: financeId || undefined,
      }));
    }

    dispatch(destroy());
    dispatch(setIsModalxOpen(false));
    return true;
  } catch (e) {
    dispatch(setError("400"));
    return false;
  }
};
